// The deal on a customer: plan, what they pay a month, the day of the
// first payment, who closed it, and whether they have stopped paying.
// The commission (salesCommission.js) is computed from these five fields.
// `compact` is the version shown inside the outcome flow when a store
// converts; the full version lives in the store drawer.
import React from 'react';
import { PLANS, PLAN_BY_KEY, money, RESIDUAL_RATE, todayIso } from './salesCommission';
import { Field, inputCls } from './salesUi';

export const dealFromProspect = (p, { me } = {}) => ({
  plan: p?.plan || '',
  monthly_amount: p?.monthly_amount != null ? String(p.monthly_amount) : '',
  billing_start: p?.billing_start || todayIso(),
  closer_rep_id: p?.closer_rep_id || p?.rep_id || me?.id || '',
  churned_at: p?.churned_at || '',
});

/** The sales_prospects patch for a form state. Empty strings become null. */
export const dealPatch = (f) => ({
  plan: f.plan || null,
  monthly_amount: f.monthly_amount !== '' && Number.isFinite(Number(f.monthly_amount)) ? Math.round(Number(f.monthly_amount) * 100) / 100 : null,
  billing_start: f.billing_start || null,
  closer_rep_id: f.closer_rep_id || null,
  churned_at: f.churned_at || null,
});

export const dealValid = (f) => Number(f.monthly_amount) > 0 && !!f.billing_start;

export default function DealForm({ value: f, onChange, reps = [], compact = false }) {
  const set = (k, v) => {
    const next = { ...f, [k]: v };
    if (k === 'plan' && PLAN_BY_KEY[v]?.amount != null) next.monthly_amount = String(PLAN_BY_KEY[v].amount);
    onChange(next);
  };
  const amt = Number(f.monthly_amount) || 0;
  return (
    <div className={`grid grid-cols-1 sm:grid-cols-2 gap-3 ${compact ? '' : ''}`}>
      <Field label="Plan">
        <select value={f.plan} onChange={(e) => set('plan', e.target.value)} className={inputCls}>
          <option value="">Pick a plan</option>
          {PLANS.map((p) => <option key={p.key} value={p.key}>{p.label}{p.amount != null ? ` · $${p.amount}` : ''}</option>)}
        </select>
      </Field>
      <Field label="They pay a month" hint={amt > 0 ? `Rep gets ${money(amt)} the first month, then ${money(amt * RESIDUAL_RATE)} a month` : 'Showrooms times the plan price, before tax'}>
        <div className="relative">
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm text-slate-400">$</span>
          <input type="number" min="0" step="1" inputMode="decimal" value={f.monthly_amount} onChange={(e) => set('monthly_amount', e.target.value)} className={`${inputCls} pl-7`} placeholder="299" />
        </div>
      </Field>
      <Field label="First payment on">
        <input type="date" value={f.billing_start} onChange={(e) => set('billing_start', e.target.value)} className={inputCls} />
      </Field>
      <Field label="Closed by" hint={compact ? undefined : 'The commission goes to this rep.'}>
        <select value={f.closer_rep_id} onChange={(e) => set('closer_rep_id', e.target.value)} className={inputCls}>
          <option value="">Nobody</option>
          {reps.map((r) => <option key={r.id} value={r.id}>{r.name}</option>)}
        </select>
      </Field>
      {!compact && (
        <Field label="Stopped paying on" hint="Leave empty while they are a customer. The 10% stops here." className="sm:col-span-2">
          <input type="date" value={f.churned_at} onChange={(e) => set('churned_at', e.target.value)} className={inputCls} />
        </Field>
      )}
    </div>
  );
}
